import './styles.scss'
import React, { useState } from 'react'
import { useFloating, offset, autoUpdate, useClick, useDismiss, useRole, useInteractions, FloatingPortal } from '@floating-ui/react'

const ChatControls = ({ isUserBlocked, onBlockUser, onUnblockUser, onClearChat }) => {
  const [isOpen, setIsOpen] = useState(false)
  const { refs, context, floatingStyles } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: 'bottom-end',
    middleware: [offset({ mainAxis: 5, crossAxis: 6 })],
    strategy: 'absolute',
    whileElementsMounted: autoUpdate
  })

  const click = useClick(context)
  const dismiss = useDismiss(context, {
    outsidePressEvent: 'mousedown'
  })
  const role = useRole(context, { role: 'menu' })
  const close = () => setIsOpen(false)

  const { getReferenceProps, getFloatingProps } = useInteractions([click, dismiss, role])

  const Item = ({ icon, label, onClick, danger }) => (
    <button
      className={`chat-control__item${danger ? ' danger' : ''}`}
      role="menuitem"
      onClick={() => {
        onClick && onClick()
        close()
      }}
    >
      {icon && <i className={`pi ${icon} ${label === 'Reply' ? 'reply-icon' : ''}`} aria-hidden="true" />}
      <span>{label}</span>
    </button>
  )

  const handleClick = () => {
    setIsOpen(!isOpen)
  }

  return (
    <>
      <div
        ref={refs.setReference}
        {...getReferenceProps({
          type: 'button',
          className: 'chat-control-menu-button',
          'aria-label': 'Message options',
          onClick: handleClick
        })}
      >
        <i className="pi pi-ellipsis-v" />
      </div>

      {isOpen && (
        <FloatingPortal>
          <div ref={refs.setFloating} style={floatingStyles} {...getFloatingProps()} className="user-menu">
            <Item icon="pi-minus-circle" label="Clear chat" onClick={onClearChat}></Item>
            {isUserBlocked ? <Item icon="pi-ban" label="Unblock" onClick={onUnblockUser}></Item> : <Item icon="pi-ban" label="Block" danger onClick={onBlockUser}></Item>}
          </div>
        </FloatingPortal>
      )}
    </>
  )
}

export default ChatControls
